var viewer_rtlignore_default = {
  "gallery_container": "bQX8G",
  "imageTitleContainer": "LMBFL",
  "clickableItem": "j5EP0",
  "prerender": "hzQFw",
  "expandContainer": "_7zx7v",
  "expandIcon": "xV9kS",
  "itemOverlay": "nY13j",
  "imageTitle": "b6TDW",
  "pointer": "hP8jP",
  "fadeIn": "Ju-wr",
  "changing_background": "ErzgL"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
